import { getMessage } from '@/services/pns.ts'
import chat from '@/model/Chat.ts'

export const fetchMessage = async (contact, lastItem?) => {
  return getMessage({
    // lastId: lastItem?.id,
    prevId: lastItem?.id,
    fromType: contact.type || 'APP',
    fromId: contact.id,
  }).then((res: any) => {
    const messageItems = res?.map?.(item => chat.convertMessage(contact, item)) || []
    // appendMessageData([messageItem, ...messageItems])
    return messageItems
  })
}
